export const cacheService = {
  DEFAULT_CACHE_HOURS: 0,

  // get: (key) => {
  //   try {
  //     const item = sessionStorage.getItem(key);
  //     if (!item) return null;

  //     const { data, timestamp, expirationHours } = JSON.parse(item);
  //     const now = new Date().getTime();
  //     const expirationTime = timestamp + expirationHours * 60 * 60 * 1000;

  //     if (now > expirationTime) {
  //       sessionStorage.removeItem(key);
  //       return null;
  //     }

  //     return data;
  //   } catch (error) {
  //     console.error("Error reading from cache:", error);
  //     return null;
  //   }
  // },

  get: (_key) => {
    // Cache is disabled
    return null;
  },

  set: (key, data, expirationHours = cacheService.DEFAULT_CACHE_HOURS) => {
    try {
      const cacheItem = {
        data,
        timestamp: new Date().getTime(),
        expirationHours,
      };
      sessionStorage.setItem(key, JSON.stringify(cacheItem));
    } catch (error) {
      console.error("Error writing to cache:", error);
    }
  },

  generateKey: (personalId, opts) => {
    return `myLearning_${personalId}_${JSON.stringify(opts)}`;
  },

  clearCache: (personalId) => {
    try {
      const cacheKeys = Object.keys(sessionStorage).filter((key) =>
        key.startsWith(`myLearning_${personalId}`),
      );

      cacheKeys.forEach((key) => {
        sessionStorage.removeItem(key);
      });
    } catch (error) {
      console.error("Error clearing cache:", error);
    }
  },

  validateCache: (data) => {
    return (
      data &&
      Array.isArray(data.courses) &&
      Array.isArray(data.trainingCategories)
    );
  },
};
